import { isly } from "isly";
export var Minute;
(function (Minute) {
    var _a;
    Minute.values = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
    ];
    _a = isly
        .string("value", ...Minute.values)
        .rename("isoly.Time.Minute")
        .bind(), Minute.type = _a.type, Minute.is = _a.is, Minute.flawed = _a.flawed;
    let Numeric;
    (function (Numeric) {
        var _a;
        Numeric.values = [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
            31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
            59,
        ];
        _a = isly
            .number("value", ...Numeric.values)
            .rename("isoly.Time.Minute.Numeric")
            .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    })(Numeric = Minute.Numeric || (Minute.Numeric = {}));
    function parse(value) {
        return Minute.is(value) ? Minute.Numeric.type.get(Number.parseInt(value)) : undefined;
    }
    Minute.parse = parse;
    function create(value) {
        return Minute.type.get(value.toString().padStart(2, "0"));
    }
    Minute.create = create;
})(Minute || (Minute = {}));
//# sourceMappingURL=Minute.js.map